import { ChainInfo } from 'api/v1/chains'
import { FC, memo, useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { updateSelectFast } from 'store/withdraw/actions'
import { useSelectedToken, useSelectFast } from 'store/withdraw/hook'
import { Space12, Space8 } from 'styles'
import { BootstrapTooltip, FromTip, SupportButtons } from './style'
import {
  FAST_WITHDRAWAL_ESTIMATE_TIME,
  STANDARD_WITHDRAWAL_ESTIMATE_TIME,
} from '../../constants/withdrawal'
import { ReactComponent as IconFast } from './assets/fast.svg'
import { ReactComponent as IconSelected } from './assets/selected.svg'
import { MainnetChainIds } from 'constants/chains'

const WithdrawSpeed: FC<{
  selectedNetwork: ChainInfo | undefined
}> = memo(({ selectedNetwork }) => {
  const selectedToken = useSelectedToken()
  const selectFast = useSelectFast()
  const dispatch = useDispatch()

  const selectedTokenChain = useMemo(() => {
    if (selectedNetwork?.layerTwoChainId) {
      return selectedToken?.chains?.[selectedNetwork.layerTwoChainId]
    }
    return undefined
  }, [selectedToken, selectedNetwork])

  useEffect(() => {
    dispatch(updateSelectFast(!!selectedTokenChain?.fastWithdraw))
  }, [dispatch, selectedTokenChain])

  const standardWithdrawalEstimateTime =
    selectedNetwork?.layerOneChainId === MainnetChainIds.Ethereum
      ? '24-48 hours'
      : STANDARD_WITHDRAWAL_ESTIMATE_TIME
  return (
    <>
      <Space12 />
      <FromTip>
        Est. withdrawal time:{' '}
        {selectFast ? (
          <b>{FAST_WITHDRAWAL_ESTIMATE_TIME}</b>
        ) : (
          <b>{standardWithdrawalEstimateTime}</b>
        )}
      </FromTip>
      <Space8 />
      <SupportButtons>
        <BootstrapTooltip
          title="Decentralized withdrawal at lower cost"
          placement="bottom-start"
        >
          <div
            onClick={() => dispatch(updateSelectFast(false))}
            className={`slow ${!selectFast ? 'active' : ''}`}
          >
            Standard
            <IconSelected className="icon-selected" />
          </div>
        </BootstrapTooltip>
        <BootstrapTooltip
          title={
            selectedTokenChain?.fastWithdraw
              ? 'Faster withdrawal via broker at higher cost'
              : 'Withdrawal via broker not available for this token'
          }
          placement="bottom-start"
          className="arrow"
        >
          <div
            onClick={() => {
              if (selectedTokenChain?.fastWithdraw) {
                dispatch(updateSelectFast(true))
              }
            }}
            className={`fast ${selectFast ? 'active' : 'disable'} ${
              !selectedTokenChain?.fastWithdraw ? 'disable' : ''
            }`}
          >
            <IconFast className="icon-fast" />
            Fast
          </div>
        </BootstrapTooltip>
      </SupportButtons>
    </>
  )
})
export default WithdrawSpeed
